import * as yup from 'yup';

import {
  format,
  getHours,
  getMinutes,
  isValid,
  parse,
  parseISO,
  set,
} from 'date-fns';
import { appointmentDateTime } from '@/features/fhir/helpers/appointment';
import { toInternalCodeableConceptValue } from '../components/ArtifactForm/ArtifactForm.business';
import { FieldProxy } from '../components/ArtifactForm/ArtifactForm.fields';

import {
  AgendamentoDateWidget,
  AgendamentoTimeWidget,
} from './Agendamento.widgets';

const AgendamentoForm = [
  FieldProxy({
    name: 'reasonCode',
    label: 'Motivo',
    widget: 'paragraph',
    validator: yup
      .string()
      .required('Por favor, digite o motivo para continuar'),
    fhirPath: 'reasonCode.select(text | coding.display).first()',
    propertyPath: 'reasonCode',
    required: true,
    setValue: (resource, value) =>
      toInternalCodeableConceptValue(resource, 'reasonCode', value, true),
  }),
  FieldProxy({
    name: 'startDate',
    label: 'Data',
    widget: AgendamentoDateWidget,
    validator: yup.string().required('Por favor, digite a data para continuar'),
    propertyPath: 'start',
    required: true,
    getValue: fhirData => {
      const dateTime = appointmentDateTime(fhirData as fhir4.Appointment);

      if (!dateTime) {
        return '';
      }

      return format(dateTime, 'yyyy-MM-dd');
    },
    setValue: (resource, value) => {
      const appointment = resource as fhir4.Appointment;

      const dateBase = parse(value as string, 'yyyy-MM-dd', new Date());
      const existingDate = appointment.start
        ? parseISO(appointment.start)
        : null;
      const hours =
        existingDate && isValid(existingDate) ? getHours(existingDate) : 0;
      const minutes =
        existingDate && isValid(existingDate) ? getMinutes(existingDate) : 0;

      const newDateTime = set(dateBase, {
        hours,
        minutes,
        seconds: 0,
        milliseconds: 0,
      });

      return {
        ...appointment,
        start: newDateTime.toISOString(),
      };
    },
  }),
  FieldProxy({
    name: 'startTime',
    label: 'Horário',
    widget: AgendamentoTimeWidget,
    validator: yup.string(),
    propertyPath: 'start',
    getValue: fhirData => {
      const appointment = fhirData as fhir4.Appointment;

      if (!appointment.start) {
        return '';
      }

      const parsed = parseISO(appointment.start);

      return isValid(parsed) ? format(parsed, 'HH:mm') : '';
    },
    setValue: (resource, value) => {
      const appointment = resource as fhir4.Appointment;
      const [hours, minutes] = (value as string)
        .split(':')
        .map(n => parseInt(n, 10));

      const baseDate =
        appointment.start && isValid(parseISO(appointment.start))
          ? parseISO(appointment.start)
          : new Date();

      const changedDateTime = set(baseDate, {
        hours,
        minutes,
        seconds: 0,
        milliseconds: 0,
      });

      return {
        ...appointment,
        start: changedDateTime.toISOString(),
      };
    },
    unsetValue: resource => resource,
  }),
  FieldProxy({
    name: 'description',
    label: 'Observação',
    widget: 'paragraph',
    fhirPath: 'description',
    propertyPath: 'description',
    setValue: (resource, value) => ({
      ...resource,
      description: value,
    }),
  }),
];

export default AgendamentoForm;
